var _symbol, _view;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "_wifi",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "1s",
    begin: 0,
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,45.3c-3.1,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5c3,0,5.5-2.5,5.5-5.5C37.5,47.8,35,45.3,32,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,37.8c-3.6-3.6-8.4-5.6-13.6-5.6c-5.1,0-9.9,2-13.5,5.6c-1.4,1.4-1.5,3.8,0,5.3c0.7,0.7,1.7,1.1,2.7,1.1                 s1.9-0.4,2.6-1.1c2.2-2.2,5.1-3.4,8.2-3.4c3.1,0,6.1,1.2,8.2,3.4c0.7,0.7,1.7,1.1,2.7,1.1c1,0,1.9-0.4,2.6-1.1                 C47,41.6,47,39.2,45.5,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9,20.4C54.7,12.2,43.7,7.7,32,7.7c-11.7,0-22.6,4.5-30.9,12.7c-1.5,1.5-1.5,3.8,0,5.3c0.7,0.7,1.6,1.1,2.6,1.1                 c1,0,1.9-0.4,2.7-1.1c6.8-6.8,15.9-10.6,25.6-10.6c9.7,0,18.8,3.8,25.6,10.6c0.7,0.7,1.7,1.1,2.7,1.1s1.9-0.4,2.6-1.1                 C64.4,24.2,64.4,21.9,62.9,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,29.3c-5.9-5.8-13.7-9.1-22-9.1c-8.3,0-16.1,3.2-22,9.1c-0.7,0.7-1.1,1.7-1.1,2.7c0,1,0.4,1.9,1.1,2.6                 c0.7,0.7,1.6,1.1,2.6,1.1c1,0,1.9-0.4,2.6-1.1c4.5-4.4,10.4-6.9,16.7-6.9c6.3,0,12.2,2.4,16.7,6.9c0.7,0.7,1.6,1.1,2.6,1.1                 c1,0,1.9-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.6C55.1,31,54.7,30,54,29.3z"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_wifi",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 64
  }), _view || (_view = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "wifi",
    viewBox: "64 0 64 64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/icon_wifi.3afae9dae65ff063ffbdf4308f4b41d1.svg";
export { ForwardRef as ReactComponent };